import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const connectionString = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING as
  | string
  | undefined;

let appInsights: ApplicationInsights | null = null;

if (connectionString && connectionString.includes('InstrumentationKey=')) {
  try {
    appInsights = new ApplicationInsights({
      config: {
        connectionString,
        enableAutoRouteTracking: true,
        disableFetchTracking: false,
        disableAjaxTracking: false,
        enableCorsCorrelation: true,
        correlationHeaderExcludedDomains: ['*.auth0.com', 'auth.guestivo.pl'],
      },
    });

    appInsights.loadAppInsights();
    appInsights.trackPageView();
  } catch {
    appInsights = null;
  }
}

export { appInsights };
